import { IconComponent } from "../types";
import { ReactComponent as TrashSvgIcon } from "./../../../assets/icons/trash.svg";

const TrashIcon: IconComponent = ({ size, color }) => {
  return <TrashSvgIcon width={size} height={size} color={color} />;
};

export default TrashIcon;
